module.exports = __webpack_public_path__ + "static/media/grimace-regular.35ea4d45.svg";